import SERVICE_TYPES from 'constants/SERVICE_TYPES';
import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

const SERVICE_LINKS = [
    { key: SERVICE_TYPES.VIDEO_HOSTING, title: 'Video Hosting', path: '/vhs' },
    { key: SERVICE_TYPES.PROGRAM_ENGINE, title: 'Program Engine', path: '/program-engine' },
    { key: SERVICE_TYPES.COMMUNITY, title: 'Community', path: '/community/moderator' },
    { key: SERVICE_TYPES.ADMINS, title: 'Admins', path: '/admins' },
];

function mapStateToProps(state) {
    return {
        user: state.user.user,
    };
}

function Dashboard({ user }) {
    const services = user?.permissions?.services || [];
    const hasAll = services.includes('all');
    const visibleLinks = hasAll
        ? SERVICE_LINKS
        : SERVICE_LINKS.filter((link) => services.includes(link.key));

    return (
        <section>
            <h1 className="admin-section-title">Dashboard</h1>
            {user?.display_name && (
                <p className="mb-6">Welcome, {user.display_name}</p>
            )}
            <ul className="flex flex-wrap gap-4">
                {visibleLinks.map((link) => (
                    <li key={link.key}>
                        <NavLink
                            to={link.path}
                            className={({ isActive }) =>
                                isActive
                                    ? 'active rounded-md px-4 py-2'
                                    : 'hover:rounded-md px-4 py-2'
                            }
                        >
                            {link.title}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </section>
    );
}

export default connect(mapStateToProps)(Dashboard);
